import { render } from "./TopbarDefault.vue?vue&type=template&id=1d53a414"
import script from "./TopbarDefault.vue?vue&type=script&lang=js"
export * from "./TopbarDefault.vue?vue&type=script&lang=js"

import "./TopbarDefault.vue?vue&type=style&index=0&id=1d53a414&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/TopbarDefault.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d53a414"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d53a414', __exports__)) {
    console.log('reload')
    api.reload('1d53a414', __exports__)
  }
  
  module.hot.accept("./TopbarDefault.vue?vue&type=template&id=1d53a414", () => {
    console.log('re-render')
    api.rerender('1d53a414', render)
  })

}


export default __exports__